import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { NavLink, Link } from 'react-router-dom';
import { generateUID } from '../../../helpers';

class NavigationLink extends Component {
    constructor(props) {
		super(props);
		this.state = {
            isOpen: false,
            isSubOpen: false,
            uid: '',
		}
    }

    componentDidMount() {
        // Accessibility - Geenrate uid for aria-controls attribute
        this.setState({
            uid: generateUID(),
        });
    }

    toggleSubnav = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    }

    toggleSubSubnav = () => {
        this.setState({
            isSubOpen: !this.state.isSubOpen,
        });
    }

    toggleNav = () => {
        this.setState({
            isOpen: false,
        });
        this.props.toggleNav();
    }

    renderSublink = (subLink, index) => {
        if (subLink.external) {
            return (
                <a href={subLink.url}
                className={"showtix-navigation__link"}
                target="_blank" rel="noopener">{subLink.title}</a>
            );
        }

        if (subLink.subLinks) {
            return (
                <React.Fragment>
                    <button
                        className={"showtix-navigation__link title" + (this.state.isSubOpen ? ' is-open' : '')}
                        onClick={() => this.toggleSubSubnav()}
                        aria-expanded={this.state.isSubOpen}
                        aria-controls={`navigation-subsublist`}
                    >
                        {subLink.title}
                    </button>
                    <ul className={"showtix-navigation__sublist " + (this.state.isSubOpen ? 'is-open' : '')} id={`navigation-subsublist`}>
                        {subLink.subLinks.map((subSubLink, j) =>
                            <li className='showtix-navigation__item' key={j}>
                                {this.renderSubSubLink(subSubLink)}
                            </li>
                        )}
                    </ul>
                </React.Fragment>
            );
        }

        if (subLink.url.indexOf('/api/') != -1) {
            return (
                <a
                    href={`${process.env.REACT_APP_SHOWTIX4U_API_HOST.replace('/api', '')}${subLink.url}`}
                    className={"showtix-navigation__link"}
                    target="_blank" rel="noopener">
                        {subLink.title}
                </a>
            );
        } else {
            return (
                <NavLink
                    className="showtix-navigation__link"
                    to={`${subLink.url}#sr-title`}
                    onClick={() => this.toggleNav()}
                >
                    {subLink.title}
                </NavLink>
            );
        }
    }

    renderSubSubLink = (subSubLink) => {
        if (subSubLink.external) {
            return (
                <a href={subSubLink.url}
                className={"showtix-navigation__link"}
                target="_blank" rel="noopener">{subSubLink.title}</a>
            );
        } else {
            return (
                <NavLink
                    className="showtix-navigation__link"
                    to={`${subSubLink.url}#sr-title`}
                    onClick={() => this.toggleNav()}
                >
                    {subSubLink.title}
                </NavLink>
            );
        }
    }

    render() {
        return (
            <li className='showtix-navigation__item'>
                {this.props.navigationLink.external ? (
                    <a href={this.props.navigationLink.url}
                       className={"showtix-navigation__link"}
                       target="_blank" rel="noopener"
                    >
                        {this.props.navigationLink.title}
                    </a>
                ) : (
                    this.props.navigationLink.subLinks.length > 0 ? (
                        <button
                            className={"showtix-navigation__link " + (this.props.navigationLink.subLinks.length > 0  ? 'title' : '') + (this.state.isOpen ? ' is-open' : '')}
                            //to={this.props.navigationLink.url}
                            onClick={(this.props.navigationLink.subLinks.length > 0  ? () => this.toggleSubnav() : () => this.toggleNav())}
                            aria-expanded={this.state.isOpen}
                            aria-controls={`navigation-sublist-${this.state.uid}`}
                        >
                            {this.props.navigationLink.title}
                        </button>
                    ) : (
                        <NavLink
                            className={"showtix-navigation__link " + (this.props.navigationLink.subLinks.length > 0  ? 'title' : '') + (this.state.isOpen ? ' is-open' : '')}
                            to={`${this.props.navigationLink.url}#sr-title`}
                            onClick={(this.props.navigationLink.subLinks.length > 0  ? () => this.toggleSubnav() : () => this.toggleNav())}
                        >
                            {this.props.navigationLink.title}
                        </NavLink>
                    )
                )}
                
                <ul className={"showtix-navigation__sublist " + (this.state.isOpen ? 'is-open' : '')} id={`navigation-sublist-${this.state.uid}`}>
                    {this.props.navigationLink.subLinks.map((subLink, j) =>
                        <li className='showtix-navigation__item' key={j}>
                            {this.renderSublink(subLink, j)}
                        </li>
                    )}
                </ul>
            </li>
        );
    }
}

NavigationLink.propTypes = {
    navigationLink: PropTypes.shape({
        external: PropTypes.bool,
        url: PropTypes.string,
        title: PropTypes.string,
        subLinks: PropTypes.array
    }),
    toggleNav: PropTypes.func
}

export default NavigationLink;



// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationLink/NavigationLink.js